import { Pagination, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	EditActionSvg,
	EyeIcon,
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon,
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { CustomUserTableProps } from './type';



const CustomTable: FC<CustomUserTableProps> = (props) => {
	const { dataSource, handleTableChange, onShowSizeChange, isLoading, search, totalRecords, performSearchHandler, performFilterHandler, filterValue, openDrawerHandler, setEditSelectedMedicine, currentPage, pageSize,  setSearch,  setTitle, allUsers, setSelectedUser,	selectedUser , selectedDate,
	setSelectedDate, viewHandler } = props

	const medicinesPermissions = useSelector(
		(state: any) => state?.userProfile
	);

	const isEditPermission = checkPermission(medicinesPermissions?.data?.permissions, {
		permissionName: 'Rejected',
		permission: ['edit'],
	});

	const isViewPermission = checkPermission(medicinesPermissions?.data?.permissions, {
		permissionName: 'Rejected',
		permission: ['view'],
	});


	const editDataHandler = (medicineObject: any) => {
		openDrawerHandler();
		setTitle('Edit Medicine');
		setEditSelectedMedicine(medicineObject);
	};

	const viewDataHandler = (medicineObject: any) => {
		viewHandler(medicineObject);
	};

	return (
		<>
			<div className={`${styles['body']} user-table`} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'Medicine List'}
					openDrawerHandler={openDrawerHandler}
					setSearch={setSearch}
					allUsers={allUsers}
					setSelectedUser={setSelectedUser}
					selectedUser={selectedUser}
					selectedDate={selectedDate}
					setSelectedDate={setSelectedDate}
					totalRecords={totalRecords}
				/>

				<Table
					rowKey={(record: any) => record?.id}
					dataSource={dataSource}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ padding: '0 10px' }}>Medicine Name</p>}
						dataIndex="medicineName"
						key="medicineName"
						className="user-column bg-white"
						width={'15%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>
					<Column
						title="Manufacturer"
						dataIndex="manufacturer"
						key="manufacturer"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>


					<Column
						title="Brand"
						dataIndex="brandName"
						key="brandName"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Mrp"
						dataIndex="mrp"
						key="mrp"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Marketed By"
						dataIndex="marketedBy"
						key="marketedBy"
						className="bg-white"
						width={'10%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Rejected By"
						key="rejectedBy"
						className="bg-white"
						width={'10%'}
						render={(_, record:any) =>
							record.MedicineRejection?.[0]?.rejectedByUser?.fullName || '-'
						}
					/>

					<Column
						title="Rejected reason"
						key="rejectedBy"
						className="bg-white"
						width={'10%'}
						render={(_, record: any) =>
							record.MedicineRejection?.[0]?.reason || '-'
						}
					/>

					{(isViewPermission || isEditPermission)  && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'15%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{
											isViewPermission  ? (
												<div
													className="cursor-pointer flex align-center justify-center  "
													onClick={() =>
														viewDataHandler(data)
													}
												>
													<EyeIcon />
												</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center  ">
													<EyeIcon />
												</div>
											)}


										{isEditPermission? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

												<EditActionSvg />
											</div>
										)}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};


export default CustomTable;
